<template>
  <v-autocomplete
    outlined
    :clearable="!readonly"
    :disabled="disabled"
    :items="[...items, ...listDisabled]"
    :value="value"
    :label="model.title"
    :error-messages="error"
    :hide-details="config.hideDetails || false"
    :dense="config.dense || false"
    :readonly="readonly"
    item-text="text"
    item-value="user_id"
    @input="onInput($event)"
    @keydown="onKeyDown"
    :small-chips="model.chips || false"
    :multiple="model.chips || false"
    :deletable-chips="model.chips && !readonly"
    :hide-selected="model.chips || false"
    :return-object="(model.chips && (model.returnObject == undefined || model.returnObject)) || false"
  >
    <template v-slot:selection="data" v-if="model.chips || false">
      <v-chip v-bind="data.attrs" :input-value="data.selected" :close="config.readonly != true" small @click="data.select" @click:close="remove(data.item)" class="mt-1">
        {{ data.item.text }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  // mixins: [modelOptions],
  props: {
    value: [Array, Number, Object],
    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {} },
  },
  data() {
    return {
      data: [],
      listDisabled: [],

      showAllItem: false,
    };
  },
  beforeCreate() {},
  created() {
    this.fetchData();
  },
  watch: {
    model: {
      handler(n, o) {
        if (n.api?.filters !== o.api?.filters) this.fetchData();
        //this.tests = this.data.test_data || [];
      },
      deep: true,
    },
  },
  computed: {
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
    api() {
      return "mechti/tasks/users/select";
    },
    roles() {
      let res = (this.$dir.get("roles") || []).map((item) => ({ ...item }));
      return res;
    },
    items() {
      let res = [];
      let resD = [];
      this.data.forEach((d) => {
        if (d.user_id == this.value) res.push(d);
        else {
          if (!this.checkDisabled(d)) res.push(d);
          else resD.push(d);
        }
      });
      //    this.listDisabled = [...resD];
      return res;
    },
    job() {
   
      return (this.$dir.get("job") || []).map((item) => ({ ...item }));
    },
    employee() {
      return (this.$dir.get("employee") || []).map((item) => ({ ...item }));
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "*") {
        this.showAllItem = !this.showAllItem;
        e.preventDefault();
      }
    },
    checkDisabled(e) {
      if (this.showAllItem) return false;
      if (e?.isActive === false || e.hidden) return true;
      if (this?.model?.activeFormula) {
        const formula = this.model.activeFormula;
        //console.log("checkDisabled formula", formula, e.role, e);
        let func;
        if (typeof formula == "function") func = formula;
        if (typeof formula == "string") func = eval(formula);
        return !func(e);
      }
      return false;
    },
    remove(item) {
      if (this.readonly) return;
      const index = this.value.findIndex((el) => {
        return el.user_id == item.user_id;
      });
      if (index >= 0) this.value.splice(index, 1);
    },
    onInput(e) {
      this.$emit("input", e);
    },
    async fetchData() {
      this.loading = true;
      let params = {};
      if (this.model?.api?.filters) params.filters = this.model.api.filters;
      params.sort = { key: "name", order: "ASC" };
      //let response = await this.$axios.get(this.api, { params });
      let response = await this.$axios.post("/report_sql/filters", { name: "getUserListForSelect", params: { type: "1", status: [1] }, filters: params.filters });
      //let response = await this.$axios.post("/report_sql", { name: "getUserListForSelect", params: { type: "1" } });

      this.loading = false;
      //console.log("users", response.data);
      let data = [];
      let curr = [];
      if (this.value)
        curr =
          typeof this.value == "object"
            ? this.value.map((v) => {
                return v.user_id;
              })
            : [this.value];

      for (let el of response.data.data) {
        if (el.status == 1 || (curr && curr.includes(el.value))) {
          data.push({
            user_id: el.value,
            role: el.role,
            status: el.status,
            text: el.text,
            /*
              " (" +
              this.roles.find(r => {
                return r.value == el?.role;
              })?.text +
              ")", */
          });
        }
      }
      //response.data.data
      this.data = data;
    },
  },
};
</script>
<style lang="scss"></style>
